// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveFilters_wrapper__HhtIj","clearFilters":"ActiveFilters_clearFilters__f3Vy1"};